<main class="main-wrap">
  <div class="left-sidebar-wrapper" *ngIf="deviceType !== 'mobile'">
    <app-industry-report-action-page></app-industry-report-action-page>
  </div>
  <div class="middle-wrapper">
    <app-industry-report-details-page></app-industry-report-details-page>
  </div>
  <div class="right-sidebar-wrapper" *ngIf="deviceType !== 'mobile'">
    <app-industry-report-competitor-page></app-industry-report-competitor-page>
  </div>
</main>
